// Ключ линии по всем её точкам (не по концам и длине: бэкенд прореживает
// линии до одинакового числа точек, а маршруты от одной стоянки начинаются
// в одной точке). 5 знаков после запятой - около метра, точнее не нужно.
export const lineKey = (line: readonly (readonly number[])[] | null | undefined): string =>
  line ? line.map((p) => `${Number(p[0]).toFixed(5)},${Number(p[1]).toFixed(5)}`).join(";") : "";
